import stringify from "json-stringify-pretty-compact";
export default class CodeRenderer {
    constructor() {
        this.codeBox = document.getElementById('code');
    }
    render(app, appIndex) {
        var _a, _b;
        if (appIndex !== undefined && app.appIndex !== appIndex) {
            return;
        }
        if (!this.codeBox) {
            return;
        }
        const scene = (_a = app.scenes) === null || _a === void 0 ? void 0 : _a[(_b = app.sceneIndex) !== null && _b !== void 0 ? _b : 0];
        this.codeBox.value = scene ? stringify(scene) : "";
        this.timeout = setTimeout(() => this.render(app), 100);
    }
    onChange(app) {
        clearTimeout(this.timeout);
        this.render(app);
    }
}
